import { composeFieldPath } from '@northfork/basics'
import { Transaction } from '../transaction'

export interface WireTransfer extends Transaction {
  securityId?: number
  sourcePostDate?: string
  destPostDate?: string
  sourceClearedDate?: string
  destClearedDate?: string
  units: number
  destAccountId?: number
  postDate: string
  sourceAccountId?: number
}

export const wireTransferField = composeFieldPath([] as WireTransferModel[])

export interface WireTransferModel {
  id: keyof WireTransferMappingRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  isEditable: boolean
  type: 'string' | 'number' | 'date'
  field: string
  value: string | boolean
  errorMessage?: string
}

export interface WireTransferMappingRow {
  cusip: string
  cwanIdentifier: string
  entryDate: string
  sourceAccountId: string
  sourcePostDate: string
  sourceCleared: boolean
  destAccountId: string
  destPostDate: string
  destCleared: boolean
  units: string
}
